export const checkUserMedia = () => {
    return checkMediaPermission();
}

async function checkMediaPermission() {
    try {
        await navigator.mediaDevices.getUserMedia({
            audio: true,
        });
        return true;
    } catch {
        return false;
    }
}
